import styled from "styled-components";

export const FooterWrapper = styled.footer`
  margin-top: clamp(40px, 6vw, 80px);

  overflow: visible;

  /* Keep footer text outside the fixed assistant controls without narrowing
     the page or removing the full-width footer background. */
  > [data-footer-text-region] {
    padding-right: calc(clamp(76px, 16vw, 180px) + 24px);
  }


  border-top-left-radius: 90px;
  border-top-right-radius: 90px;

  background-color: #005f63;
  background-image: linear-gradient(180deg, #005f63 0%, #23488f 100%);
  color: #ffffff;

  @media (max-width: 480px), (max-height: 360px) {
    > [data-footer-text-region] {
      padding-right: calc(clamp(64px, 20vw, 96px) + 24px);
      padding-left: 16px;
    }
  }

  @media (max-width: 640px) {
    border-top-left-radius: 42px;
    border-top-right-radius: 42px;
  }


`;

export const FooterContent = styled.div.attrs({ "data-footer-text-region": true })`
  max-width: 1700px;
  margin: auto;
  padding: 40px 80px 25px;
  display: grid;
  grid-template-columns:
    1.3fr
    1fr
    1fr
    1.2fr
    1fr;

  gap: 30px;

  > * {
    min-width: 0;
  }

  @media (max-width: 1200px) {
    grid-template-columns: repeat(3, minmax(0, 1fr));
    gap: 40px;
    padding: 40px 48px 24px;
  }

  @media (max-width: 960px) {
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 32px;
    padding: 36px 28px 24px;
  }

  @media (max-width: 640px) {
    grid-template-columns: 1fr;
    padding-inline: 22px;
  }
`;

export const FooterUnderline = styled.div`
  width: 30px;
  height: 7px;
  border-radius: 999px;
  background: #f3a90d;
  margin-top: 10px;
  margin-bottom: 5px;
`;

export const FooterText = styled.p`
  color: white;
  font-size: 14px;
  overflow-wrap: anywhere;
  text-align: justify;
`;

export const FooterLink = styled.a`
  display: block;
  color: white;
  font-size: 14px;
  margin-bottom: 5px;
  cursor: pointer;
  text-decoration: none;
  overflow-wrap: anywhere;
`;

export const FooterNotice = styled.div.attrs({ "data-footer-text-region": true })`
  max-width: 1700px;
  margin: 0 auto;
  padding: 0 clamp(20px, 4vw, 80px) 16px;
  color: white;
  text-align: center;
  font-size: 14px;
  line-height: 1.5;
  font-weight: 400;
  overflow-wrap: anywhere;

  p {
    margin: 0;
    font-size: inherit;
    line-height: inherit;
    font-weight: inherit;
  }
`;

export const FooterBottom = styled.div.attrs({ "data-footer-text-region": true })`
  min-height: 42px;
  background: #243857;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px clamp(16px, 4vw, 50px);
  flex-wrap: wrap;
  color: white;
  font-size: 14px;
  line-height: 24px;
  gap: 20px;

  > div {
    min-width: 0;
  }

  > div:nth-child(2) {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 12px 32px;

    > a, > span, > div > button {
      white-space: nowrap;
    }
  }

  a { color: inherit; text-decoration: none; }
  a:hover { text-decoration: underline; }
  a:focus-visible { outline: 2px solid #f3a90d; outline-offset: 3px; }

  @media (max-width: 560px) {
    flex-direction: column;
    gap: 4px;
    padding: 6px 16px;
    font-size: 13px;
    line-height: 20px;

    > div:nth-child(2) {
      flex-wrap: wrap;
      justify-content: center;
      gap: 4px 16px;

      > a, > span, > div > button {
        white-space: nowrap;
      }

      > div > button {
        padding: 2px 6px;
      }
    }
  }
`;
